import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=13b14c38&scoped=true"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=13b14c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b14c38",
  null
  
)

export default component.exports